module.exports = __webpack_public_path__ + "static/media/MATIC-BNB.af3a951a.svg";